import { Middleware } from "@reduxjs/toolkit";
import { handleSessionExpiredLogout } from "../features/auth/services/auth";
// import { useToast } from "../components/toast/ToastContext";

let hasTriggered401Logout = false;

const tokenRefresher: Middleware = () => (next) => (action: any) => {
    // const showToast=useToast();
  const result = next(action);

  // Check if it's an API rejection with 401
  if (action?.type?.endsWith("/rejected") && action?.payload?.status === 401) {
    // Refresh flow temporarily disabled to avoid repeated retry loops.
    // console.warn("401 detected, attempting token refresh...");
    // void refreshToken().then((newAccessToken) => {
    //   if (newAccessToken) {
    //     // Retry logic could be here if needed
    //     console.info("Token refreshed successfully.");
    //   } else {
    //     localStorage.removeItem("authData");
    //     window.location.href = "/";
    //   }
    // });

    if (!hasTriggered401Logout) {
      hasTriggered401Logout = true;
      handleSessionExpiredLogout();
    }
  }

  return result;
};

export default tokenRefresher;
